module.exports = new __parcel__URL__("mid-tom_9.211b9f20.mp3").toString();